module.exports = __webpack_public_path__ + "img/Medical_Program_icon02.f275ff9f.png";